import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PopupChange } from "../../reducers/config";
import "./css/index.css";
import { RootState } from "../../reducers";
import {
  InvitationInter,
  InvitationLaeder,
  InvitationList,
  InvitationProject,
} from "../../reducers/data";
import { useNavigate } from "react-router-dom";
import { officeApi } from "../../api/config";
import WpInput from "../../components/WriteProject/WpInput/WpInput";
import CouponUserList from "../../components/CouponUserList/CouponUserList";
function Invitation() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { list, leader, project } = useSelector<RootState, InvitationInter>(
    (state) => state.data.insertInvitation
  );
  const [period, setPeriod] = useState<string>("");

  const SpliceUser = useCallback(
    (index: number) => {
      const clone = list.slice();
      clone.splice(index, 1);
      dispatch(InvitationList(clone));
    },
    [list, dispatch]
  );

  const __searchUser = useCallback(() => {
    dispatch(
      PopupChange({
        active: true,
        type: "coupon",
        content: "invitation",
      })
    );
  }, [dispatch]);

  const __teamUser = useCallback(() => {
    dispatch(
      PopupChange({
        active: true,
        type: "leader",
        content: "invitation",
      })
    );
  }, [dispatch]);

  const __projectUser = useCallback(() => {
    dispatch(
      PopupChange({
        active: true,
        type: "project",
        content: {
          id: leader.id,
          name: leader.name,
        },
      })
    );
  }, [dispatch, leader]);

  const UpdateCommon = useCallback((type: string, payload: string | number) => {
    setPeriod(String(payload));
  }, []);
  const __insertInvitation = useCallback(() => {
    const usr_lst = list.map((item) => {
      return {
        usr_id: item.usr_id,
      };
    });
    officeApi
      .post(`/cstm/cpon`, {
        cpon_nm: project.title,
        prjt_id: project.id,
        cpon_discnt_rate: 100,
        cpon_type_cd: "inbi",
        cpon_ctg_cd: "prjt",
        cpon_apply_en_at: new Date(period),
        usr_lst,
      })
      .then(({ data }) => {
        // if (sts_fg) {
        //   navigate("/etc/coupon");
        // }
      });
    navigate(-1);
  }, [navigate, list, period, project]);

  useEffect(() => {
    dispatch(InvitationProject({ id: "", title: "" }));
    dispatch(InvitationList([]));
    return () => {};
  }, [leader]);

  useEffect(() => {
    return () => {
      dispatch(
        InvitationLaeder({
          id: "",
          name: "",
          email: "",
        })
      );
    };
  }, [dispatch]);

  return (
    <main className="invitation-page">
      <div className="wrapper">
        <div className="header">
          <div className="left">
            <div className="title">인비테이션 발급</div>
            <div className="menu"></div>
          </div>
        </div>
        <div className="main">
          <div className="mainleft">
            <div className="select-box">
              <div className="title">팀 리더</div>
              <div
                className={`box ${leader.id ? "selected" : ""}`}
                onClick={__teamUser}
              >
                {leader.id
                  ? leader.name
                    ? leader.name
                    : "선택 완료"
                  : "팀 리더 선택"}
                <img
                  src="/assets/project/right-arrow.svg"
                  className="img"
                ></img>
              </div>
            </div>
            <div className="select-box">
              <div className="title">대상 프로젝트</div>
              <div
                className={`box ${project.title ? "selected" : ""}`}
                onClick={() => {
                  if (leader.id) {
                    __projectUser();
                  }
                }}
              >
                {project.title ? project.title : "프로젝트 선택"}
                <img
                  src="/assets/project/right-arrow.svg"
                  className="img"
                  alt=""
                />
              </div>
            </div>
            <div className="select-box">
              <div className="title">발급 대상 검색</div>
              <div className="box" onClick={__searchUser}>
                발급 대상 검색
                <img
                  src="/assets/project/right-arrow.svg"
                  className="img"
                ></img>
              </div>
            </div>

            <div className="input-box">
              <WpInput
                title="사용기한"
                placeholder="YYYY-MM-DD"
                initial={period}
                max={10}
                type="text"
                reg={"finish"}
                __update={UpdateCommon}
                error={undefined}
              />
            </div>

            <div className="title">선택된 발급대상</div>
            <CouponUserList ListData={list} SpliceUser={SpliceUser} />
            <button
              className={`insert-btn ${
                leader.id &&
                project.id &&
                list.length > 0 &&
                period.length >= 10
                  ? "active-insert"
                  : ""
              }`}
              onClick={() => {
                if (
                  leader.id &&
                  project.id &&
                  list.length > 0 &&
                  period.length >= 10
                ) {
                  __insertInvitation();
                }
              }}
            >
              인비테이션 발급
            </button>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Invitation;
